import { useTranslation } from 'react-i18next';
import { FormSection, Switch } from '@zolteam/zol-admin-ui';
import { FormElements } from '@zolteam/zol-react-form';

/**
 * @typedef {object} BookingPaymentSectionProps
 * @property {{
 * payment : import('@zolteam/zol-react-form/types').ConfigObject
 * paymentHold : import('@zolteam/zol-react-form/types').ConfigObject
 * }} formConfig
 * @property {{formName: string}} formInfo - The form information object
 * @property {boolean} isPaymentHold - Whether payment is on hold
 * @property {(isHold: boolean) => void} setIsPaymentHold - Payment hold state setter
 */

/**
 * Payment section of the booking form
 * @param {BookingPaymentSectionProps} props
 * @returns {JSX.Element}
 */
function BookingPaymentSection({
  formConfig, formInfo, isPaymentHold, setIsPaymentHold,
}) {
  const { t } = useTranslation();

  return (
    <FormSection label={t('bookingForm.section.payment')}>
      <div className="margin-bottom-s">
        <Switch
          id="isPaymentHold"
          name="isPaymentHold"
          checked={isPaymentHold}
          onChange={() => setIsPaymentHold(!isPaymentHold)}
          label={t('bookingForm.actions.togglePayment')}
        />
      </div>
      <FormElements
        translations={null}
        formConfig={isPaymentHold ? formConfig.paymentHold : formConfig.payment}
        formTitle={formInfo.formName}
      />
    </FormSection>
  );
}

export default BookingPaymentSection;
